module.exports = __webpack_public_path__ + "img/date-x-close.434d1a01.svg";